import { profileType } from '../models/Profile';

let selectedProfile: string;

const getSelectedProfile = (): string | null => selectedProfile || localStorage.getItem('selectedProfile');

const setSelectedProfile = (profile: profileType) => {
    selectedProfile = profile;
    localStorage.setItem('selectedProfile', selectedProfile);
};

export { getSelectedProfile, setSelectedProfile };
